import { useQuery } from "@tanstack/react-query"
import { CompanyProfileService } from "../api/companyProfile"
import { fetchProtectedFileAsDataUrl } from "../api/protectedFiles"
import {
  fallbackCompanyProfile,
  writeStoredCompanyProfile,
} from "../utils/companyProfileStorage"

export function useCompanyProfile() {
  const query = useQuery({
    queryKey: ["companyProfile", "public"],
    queryFn: async () => {
      const profile = await CompanyProfileService.getPublicProfile()
      writeStoredCompanyProfile(profile)
      if (
        profile.labelLogoSource === "upload" &&
        profile.assets.labelLogo.startsWith("/files/")
      ) {
        try {
          return {
            ...profile,
            assets: {
              ...profile.assets,
              labelLogo: await fetchProtectedFileAsDataUrl(
                profile.assets.labelLogo,
                "company-logo",
              ),
            },
          }
        } catch {
          // Keep the canonical link so callers can distinguish an unavailable asset.
        }
      }
      return profile
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })

  return {
    ...query,
    profile: query.data ?? fallbackCompanyProfile,
  }
}
